import React from 'react'
import { IconButton } from '@material-ui/core'
import { CheckCircleOutline } from '@material-ui/icons'
import { formatRelativeDate } from '../../constants/dateHelpers'

const NotificationItem = ({ notification, onMarkRead }) => {
  const isUnread = !notification.read

  return (
    <div style={{
      padding: '10px 12px',
      backgroundColor: isUnread ? '#fff8e1' : '#fff',
      borderBottom: '1px solid #f0f0f0',
      display: 'flex',
      alignItems: 'flex-start',
      gap: 8
    }}>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 13, color: '#333' }}>{notification.message}</div>
        <div style={{ fontSize: 11, color: '#999', marginTop: 2 }}>
          {notification.actorName && <span>{notification.actorName} · </span>}
          {formatRelativeDate(notification.createdAt)}
        </div>
      </div>
      {isUnread && (
        <IconButton size="small" onClick={() => onMarkRead(notification._id)} title="Mark as read">
          <CheckCircleOutline fontSize="small" style={{ color: '#9e9e9e' }} />
        </IconButton>
      )}
    </div>
  )
}

export default NotificationItem
